import React, { Suspense, useEffect, useState } from 'react'
import { Loading } from '/src/components/loading'

// Helper to avoid React minified errors. Compiles fallback component into the static HTML pages.
// @https://github.com/mongodb/snooty/pull/1032/files
export const SuspenseHelper = ({ fallback, children }) => {
  const [isMounted, setMounted] = useState(false)

  useEffect(() => {
    if (!isMounted) {
      setMounted(true)
    }
  }, [isMounted])

  return <Suspense fallback={fallback}>{!isMounted ? fallback : children}</Suspense>
}

export const AsyncWrapper = ({ children }) => {
  return (
    <SuspenseHelper fallback={<Loading />}>
      {children}
    </SuspenseHelper>
  )
}

export default AsyncWrapper